import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HomeIfcFile } from 'situview-webapi-client';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ICompany } from 'identity-webapi-client';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'artifact-viewer-dialog',
  templateUrl: './artifact-viewer-dialog.component.html',
  styleUrls: ['./artifact-viewer-dialog.component.scss']
})
export class ArtifactViewerDialogComponent implements AfterViewInit {
  fileType: string | undefined;
  url: string | undefined;
  urlIos: string | undefined;
  posterUrl: string | undefined;

  fileName = "";
  fileIndex = -1;
  displayName = "";
  public static productPreviewFiles = [
    "product.glb", "preview.webp", "thumbnail.webp",
    "thumbnail_0_0.webp", "thumbnail_0_1.webp", "thumbnail_0_2.webp",
    "thumbnail_1_0.webp", "thumbnail_1_1.webp", "thumbnail_1_2.webp",
    "thumbnail_2_0.webp", "thumbnail_2_1.webp", "thumbnail_2_2.webp",
    "product-web.glb"
  ];

  productWidth: number = 150;
  productHeight: number = 150;
  @ViewChild('modelContainer') modelContainer: ElementRef | undefined;
  @ViewChild('imageContainer') imageContainer: ElementRef | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ArtifactViewerDialogData,
    private dialogRef: MatDialogRef<ArtifactViewerDialogData>,
    private snackBar: MatSnackBar,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef) {
      if (data?.fileName) {
        this.fileName = data.fileName;
        this.displayName = (data.displayName) ? data.displayName : "";
        this.setFileDetails();
        this.fileIndex = data.additionalFileNames?.indexOf(data.fileName) ?? -1;
      }
  }

  setFileDetails() {
    if (this.fileName.endsWith(".jpg") || this.fileName.endsWith(".jpeg")) {
      this.fileType = ".jpg";
      this.url = `${this.configService.config.situViewWebApiBaseUrl}/home/getimage?artifactid=${this.data.artifactId}&filename=${this.fileName}`;
    }
    else if (this.fileName.endsWith(".webp")) {
      this.fileType = ".webp";
      this.url = `${this.configService.config.situViewWebApiBaseUrl}/home/getimage?artifactid=${this.data.artifactId}&filename=${this.fileName}`;
    } 
    else if (this.fileName.endsWith(".png")) {
      this.fileType = ".png";
      this.url = `${this.configService.config.situViewWebApiBaseUrl}/home/getimage?artifactid=${this.data.artifactId}&filename=${this.fileName}`;
    } 
    else if (this.fileName.endsWith(".glb")) {
      this.fileType = ".glb";
      this.url = `${this.configService.config.situViewWebApiBaseUrl}/home/getglb?artifactid=${this.data.artifactId}&filename=${this.fileName}`;
      this.urlIos = `${this.configService.config.situViewWebApiBaseUrl}/home/getglb?artifactId=${this.data.artifactId}&fileName=product.usdz`;
      this.posterUrl = `${this.configService.config.situViewWebApiBaseUrl}/home/getimage?artifactid=${this.data.artifactId}&filename=preview.webp`;
    }
  }

  ngAfterViewInit(): void {
    this.resizeModelViewer();
  }

  exposureValue = 0.5;
  shadowIntensityValue = 1;
  onExposureChange(event: any) {
    this.exposureValue = event.value;
  }

  onShadowIntensityChange(event: any) {
    this.shadowIntensityValue = event.value;
  }

  private resizeModelViewer() {
    var container = this.modelContainer ?? this.imageContainer;
    if (container) {
      const parentWidth = container.nativeElement.offsetWidth;
      const parentHeight = container.nativeElement.offsetHeight;
  
      // Set the model-viewer size
      this.productWidth = parentWidth ? parentWidth * 0.9 : this.productWidth;
      this.productHeight = parentHeight ? parentHeight * 0.9 : this.productHeight;
      this.cdr.detectChanges(); // Trigger change detection manually
    }
  }

  previousFile() {
    this.fileIndex--;

    if (this.fileIndex == -1) {
      this.fileIndex = this.data.additionalFileNames!.length - 1;
    }

    this.fileName = this.data.additionalFileNames![this.fileIndex];
    this.setFileDetails();
  }

  nextFile() {
    this.fileIndex++;

    if (this.fileIndex > this.data.additionalFileNames!.length - 1) {
      this.fileIndex = 0;
    }

    this.fileName = this.data.additionalFileNames![this.fileIndex];
    this.setFileDetails();
  }

  private showMessage(message: string) {
    this.snackBar.open(message, 'OK', { duration: 2000 });
  }
}

export interface ArtifactViewerDialogData {
  fileName: string | undefined;
  artifactId: string | undefined;
  displayName: string | undefined;

  additionalFileNames: string[] | undefined;
}
